import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useClipPathId } from "../hooks/use-clip-path-id";

export function DashboardFilled(props) {
  const clipPathId = useClipPathId("dashboard-filled");
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M2.89998 12.1H9.89998C10.3 12.1 10.7 11.8 10.7 11.3V1.8C10.7 1.4 10.3 1 9.89998 1H2.89998C2.49998 1 2.09998 1.3 2.09998 1.8V11.3C2.09998 11.7 2.39998 12.1 2.89998 12.1Z"
            fill="currentColor"
          />
          <path
            d="M22.3 1H13.3C12.9 1 12.6 1.3 12.6 1.8V7.5C12.6 7.9 12.9 8.3 13.3 8.3H22.3C22.7 8.3 23 8 23 7.5V1.8C23 1.3 22.7 1 22.3 1Z"
            fill="currentColor"
          />
          <path
            d="M22.2 9.5H13.2C12.8 9.5 12.4 9.9 12.4 10.3V21.2C12.4 21.7 12.7 22 13.2 22H22.2C22.6 22 23 21.6 23 21.2V10.3C23 9.8 22.7 9.5 22.2 9.5Z"
            fill="currentColor"
          />
          <path
            d="M9.9 13.3H2.8C2.4 13.3 2 13.7 2 14.1V21.2C2 21.7 2.4 22 2.8 22H9.9C10.3 22 10.7 21.6 10.7 21.2V14.1C10.7 13.7 10.3 13.3 9.9 13.3Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect
              width={21}
              height={21}
              fill="white"
              transform="translate(2 1)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
